<template>
    <div>
        <compWrapper :title="$t('fbb.costmanage.base_info', { defaultValue: '基础信息' })" theme="primary">
            <compFormQuery v-if="type === 'query'" align="center" class="margin-top-15" :formdata="getBase" :value="formData"
                placeholder="--"></compFormQuery>
            <compFormEdit v-else ref="formbase" align="center" class="margin-top-15" :formdata="getBase" v-model="formData">
            </compFormEdit>
            <footer slot="footer">
                <vButton v-if="type !== 'query'" theme="primary" class="margin-right-15" @click="submit">
                    {{ $t('global.common.save', { defaultValue: "保存" }) }}</vButton>
                <vButton class="margin-right-15" @click="cancel">{{ $t('global.common.return', { defaultValue: '返回' }) }}
                </vButton>
            </footer>
        </compWrapper>
        <compLog v-if="type === 'query'" :columns="getLogList" wrapper :data="logList"></compLog>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>

import { HttpAddonRule, HttpSaveAddonRule, HttpGetServiceList, HttpGetServiceProductList } from "@/service/fedex";
import { HttpOtherLogiServiceList, HttpGetCarrierGroupByOrg } from "@/service/carrieraccount";
import { HttpProductList } from '@mods/service/dictionary';
import { mapGetters } from "vuex";
import mixin from '../mixin'
export default {
    mixins: [mixin],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log")
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            groupList: [],
            groupServiceList: [],
            logList: [],
            sourproductList: [],
            formData: {
                regionCode: '',
            }
        };
    },
    created() {
        this.getDetail();
        // this.getGroupServiceList(0);
    },
    computed: {
        ...mapGetters("dictionary", ["getCountryList"]),
        getBase() {
            const query = this.type === "edit";
            return [
                {
                    label: this.$t('bi.work.task_org_id', { defaultValue: "组织" }),
                    tag: "vSelect",
                    key: "orgId",
                    options: this.getOrgOpt,
                    props: {
                        filterable: true
                    },
                    on: {
                        'on-change': (val) => {
                            if (val) {
                                this.getOrgGroupList(val);
                            }
                        }
                    },
                    query,
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: "物流产品",
                    key: "groupId",
                    tag: 'vSelect',
                    options: this.groupList,
                    props: {
                        filterable: true
                    },
                    on: {
                        'on-change': (val) => {
                            if (val) {
                                this.getGroupServiceList(val);
                            }
                        }
                    },
                    // query
                    show: this.type == 'add',
                },
                {
                    label: "物流产品",
                    key: "groupName",
                    show: this.type !== 'add',
                    query
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "carrierServiceId",
                    tag: 'vSelect',
                    options: this.groupServiceList,
                    props: {
                        filterable: true
                    },
                    // on: {
                    //     'on-change': (val)=>{
                    //         this.handleCarrierChange()
                    //     }
                    // },
                    show: this.type == 'add',
                    // query
                },
                {
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "carrierServiceCode",
                    show: this.type !== 'add',
                    query,
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    tag: "div",
                    children: (h) => {
                        const region = this.getCountryList.filter(item => item.value === this.formData.regionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                    show: this.type !== 'query',
                    query: true,
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    key: 'regionCode',
                    render: (h) => {
                        const regionCountry = this.getCountryList.filter(item => item.value === this.formData.regionCode)[0]
                        return regionCountry ? regionCountry.label : '--'
                    },
                    show: this.type === 'query'
                },
                {
                    label: "项目",
                    tag: 'vSelect',
                    key: 'lineId',
                    options: this.sourproductList.map(item => {
                        return {
                            label: item.name,
                            value: item.id
                        }
                    }),
                    props: {
                        filterable: true,
                    },
                    required: false,
                    show: this.type !== 'query',
                },
                {
                    label: "项目",
                    key: 'lineName',
                    show: this.type == 'query',
                },
                {
                    label: '适用分区范围起',
                    tag: "vInputNumber",
                    key: "zoneStart",
                    props: {
                        min: 0
                    },
                    required: false,
                },
                {
                    label: '适用分区范围止',
                    tag: "vInputNumber",
                    key: "zoneEnd",
                    props: {
                        min: 0
                    },
                    required: false,
                },
                // {
                // 	label: this.$t('fbb.alloment.carrier_server', { defaultValue: '承运商服务' }),
                // 	tag: "vSelect",
                // 	key: "systemCarrierServiceId",
                // 	options: this.getCarrierServiceOpt,
                // 	props:{
                //         filterable:true
                //     },
                // 	on: {
                // 		'on-change': this.handleCarrierChange
                // 	},
                // 	query,
                // },
                {
                    label: this.$t('fbb.carrier.extra_rule_group', { defaultValue: '规则分组' }),
                    tag: "vInputNumber",
                    key: "ruleGroup",
                    props: {
                        min: 1,
                    }

                },
                {
                    label: this.$t('fbb.carrier.extra_rule_name', { defaultValue: '规则名称' }),
                    key: "ruleName"
                },
                // {
                // 	label: "匹配公式",
                // 	tag: "vTextarea",
                // 	key: "ruleRangeFormula",
                // },
                {
                    label: this.$t('fbb.carrier.extra_cost', { defaultValue: '计费值' }),
                    key: "ruleCostFormula",
                },
                {
                    label: this.$t('fbb.carrier.discount_rate', { defaultValue: '折扣率' }),
                    key: "discount",
                },
                {
                    label: this.$t('fbb.carrier.extra_rule_remark', { defaultValue: '规则描述' }),
                    tag: "vTextarea",
                    key: "remark",
                },
                {
                    label: '生效开始日期',
                    key: 'startTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label: '生效结束日期',
                    key: 'endTime',
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
            ];
        }
    },
    methods: {
        getOrgGroupList(val) {
            HttpGetServiceList({
                // HttpGetCarrierGroupByOrg({
                // contextId:global.SYSID,
                customerId: val,
            }).then(
                (res) => {
                    this.groupList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.carrierGroupCode,
                            attach: {
                                ...item
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            HttpProductList({
                contextId: val
            }).then(res => {
                this.sourproductList = res.data
            })
        },
        getGroupServiceList(val) {
            HttpGetServiceProductList({
                // HttpOtherLogiServiceList({
                contextId: global.SYSID,
                carrierGroupId: val,
                orgId: this.formData.orgId,
            }).then(
                (res) => {
                    this.getRegionCountry(val)
                    this.groupServiceList = res.data.map(item => {
                        return {
                            value: item.id,
                            label: item.code,
                            attach: {
                                ...item
                            },
                        };
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        getRegionCountry(val) {
            const groupService = this.groupList.filter(item => {
                return item.value == val
            })
            if (groupService.length > 0) {
                this.formData.regionCode = groupService[0].attach.regionCode;
            }
        },
        handleCarrierChange(value, label, attach = {}) {
            this.formData = {
                ...this.formData,
                carrierCode: attach.carrierCode,
                carrierServiceCode: attach.carrierServiceCode,
                carrierServiceName: attach.carrierServiceName,
            }
        },
        cancel() {
            this.$router.push({
                name: "carrierExtra"
            });
        },
        getDetail() {
            if (this.type === "add") return;
            this.loading = true;
            HttpAddonRule({
                id: this.id,
                orgRoleName: this.orgRoleName
            }).then(res => {
                const data = res.data || {};
                this.logList = data.carrierRuleLogs;
                delete data.carrierRuleLogs;
                this.formData = data;

                this.getOrgGroupList(this.formData.orgId);
                this.getGroupServiceList(this.formData.groupId)
                this.loading = false;
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
            });
        },
        async submit() {
            const valid = await this.$refs.formbase.validate();
            if (!valid) return;
            this.loading = true;
            HttpSaveAddonRule(this.formData).then(res => {
                this.cancel();
            }, err => {
                this.loading = false;
                this.$VMessage.error(err.message);
            })
        },
    }
};
</script>
